<template>
  <div
    class="jdgm-widget jdgm-preview-badge"
    :data-id="product.id"
    :style="shouldScrollToReviews ? 'cursor: pointer;' : ''"
    @click="shouldScrollToReviews ? handleClick($event) : null"
    v-html="badgeHtml"
  />
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: null
    },
    shouldScrollToReviews: {
      type: Boolean,
      default: false
    },
    productHandle: {
      type: String,
      default: null
    }
  },

  computed: {
    productUrl () {
      const handle = this.productHandle || this.product.handle
      return `${window.theme.shop.url}/products/${handle}`
    },

    badgeHtml () {
      return this.product?.metafields?.judgeme?.badge
        || this.product?.productMetafields?.judgeme?.badge
        || ''
    }
  },

  watch: {
    'product.id' () {
      this.$nextTick(() => this.initBadge())
    }
  },

  mounted () {
    this.$nextTick(() => this.initBadge())
  },

  methods: {
    handleClick (e) {
      e?.stopPropagation?.()

      if (this.shouldScrollToReviews) {
        window.location.href = `${this.productUrl}${window.location.search || ''}#judgeme_product_reviews`
      }
    },

    initBadge () {
      if (window.jdgm?.customizeBadges) {
        window.jdgm.customizeBadges()
      }
    }
  }
}
</script>
